import { render, staticRenderFns } from "./gs-basket-summary.vue?vue&type=template&id=f7e1e3c8"
import script from "./gs-basket-summary.vue?vue&type=script&lang=ts"
export * from "./gs-basket-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports